export default __webpack_public_path__ + "static/media/b66.4622b46a.png";